import React from "react";

export default function OrdersStats({ stats, t }) {
  return (
    <div className="mt-6 bg-white dark:bg-neutral-900 rounded-2xl border border-gray-200 dark:border-neutral-800 p-4 sm:p-5">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
        <div>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.all}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t("stats.total", "Total")}</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-amber-600 dark:text-amber-400">{stats.inProgress}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t("stats.inProgress", "In Progress")}</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">{stats.completed}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t("stats.completed", "Completed")}</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-rose-600 dark:text-rose-400">{stats.cancelled}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t("stats.cancelled", "Cancelled")}</p>
        </div>
      </div>
    </div>
  );
}
